import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  name = 'EnvDock', 
  type = 'website',
  noIndex = false 
}) => {
  const siteTitle = title ? `${title} | ${name}` : `${name} | Secure Infrastructure Vault`;
  const defaultDesc = "Securely sync and manage environment variables across your team with military-grade encryption.";

  return (
    <Helmet>
      {/* Standard Metadata */}
      <title>{siteTitle}</title>
      <meta name="description" content={description || defaultDesc} />
      
      {/* Robot Instructions (Crucial for Dashboard privacy) */}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description || defaultDesc} />

      {/* Twitter Cards */}
      <meta name="twitter:creator" content={name} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={description || defaultDesc} />
    </Helmet>
  );
};

export default SEO;